// extracted by mini-css-extract-plugin
export default {"cls1":"GIfrkDcDl4okDNTCfsdc","cls2":"swdZRSL89x4gjfBEkfq_ GIfrkDcDl4okDNTCfsdc"};